import Cookies from 'js-cookie';

export default {
  name: 'cookieManager',
  transformToHuman(val, t) {
    if ([undefined, null].includes(val)) return val;
    if (t === Boolean) return (val.toLowerCase() === 'true');
    if (t === Number) return (parseInt(val, 10));
    return val;
  },
  getAccessTokenExpiration() {
    const now = new Date();
    return new Date(now.getTime() + 60 * 60000 * 1); // 1h
  },
  getRefreshTokenExpiration() {
    const now = new Date();
    return new Date(now.getTime() + 7 * 24 * 60 * 60000); // 7 dias
  },
  getCookieExpiration() {
    return this.getAccessTokenExpiration()
  },
  // cookieAsObject(cookie) {
  //   return cookie.split(/[;] */).reduce((result, pairStr) => {
  //     const arr = pairStr.split('=');
  //     const [key, value] = arr;
  //     if (arr.length === 2) {
  //       result[key] = value; // eslint-disable-line no-param-reassign
  //     }
  //     return result;
  //   }, {});
  // },
  set(name, value, expiration) {
    if (!expiration) expiration = this.getCookieExpiration();
    expiration = expiration.toUTCString();
    document.cookie = `${name}=${value}; expires=${expiration}; path=/; Secure; SameSite=Lax;`;
  },
  get(name, t = String) {
    const val = Cookies.get(name);
    if (!val) return null;
    return this.transformToHuman(val, t);
  },
  hasReadAllAppDocuments() {
    return this.get('has_read_all_app_documents', Boolean);
  },
  /**
   * Set OTP verification status cookie
   * @param {boolean} value - Whether OTP is verified
   */
  setOtpVerified(value) {
    // Lives as long as the refresh token: the access token cookie is renewed on refresh, this one is not
    this.set('otp_verified', value ? 'true' : 'false', this.getRefreshTokenExpiration());
  },
  /**
   * Check if OTP has been verified for current session
   * @returns {boolean} True if OTP is verified
   */
  hasOtpVerified() {
    return this.get('otp_verified') === 'true';
  },
  delete(name) {
    Cookies.remove(name);
  },
  deleteAll() {
    document.cookie.split(';').forEach((c) => {
      const name = c.trim().split('=')[0];
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Lax;`;
    });
    localStorage.clear();
  },
};
